import * as React from "react";
import { useTranslation } from "react-i18next";
import "./publicBetaStyles.css";
export var PublicBeta = function () {
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "public-beta" },
            React.createElement("h1", null, t("layout.public_beta")))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/public-beta/PublicBeta.tsx
// module id = 112
// module chunks = 1